import React from "react";
import { Box, Grid2, Typography } from "@mui/material";
import CustomIcon from "../../../Components/CustomIcon";
import { Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";

const DuplicateSignal = ({ onClose }) => {
  return (
    <Box sx={{position: 'absolute', zIndex: 2000, bottom: 0}}>
        <Grid2 container alignItems={'center'} gap={1} sx={{backgroundColor: '#FFF1F1', py: 1.5, px: 2, borderRadius: '6px', display: 'inline-flex'}}>
            <CustomIcon name="alert-circle-icon" />
            <Typography variant="fw500s12c000" sx={{lineHeight: '100%', color: '#2E2E2E'}}>Duplication of Input</Typography>
            <IconButton
                onClick={onClose}
                sx={{
                    p: 0.5,
                    '&:hover': { backgroundColor: 'transparent'},
                    '&:focus': { backgroundColor: 'transparent'}
                }}
            >
                <Close color={'#494949'} sx={{ height: '14px', width: '14px' }} />
            </IconButton>
        </Grid2>
    </Box>
  )
};

export default DuplicateSignal;
